import { useParams } from "react-router-dom";
import { BidPack } from "../BidPack";
import { toBidPackWriteRequest } from "../BidPackWriteRequest";
import { useDeleteBidPack } from "../Hooks/useDeleteBidPack";
import { useFetchBidPackById } from "../Hooks/useFetchBidPackById";
import { useUpdateBidPack } from "../Hooks/useUpdateBidPack";
import { BidPackFormTabs } from "./BidPackFormTabs";

export const EditBidPack = () => {
  const { bidPackId } = useParams();

  const { data: fetchedBidPack } = useFetchBidPackById(bidPackId);
  const { mutate: updateBidPack } = useUpdateBidPack(bidPackId);
  const { mutate: deleteBidPack } = useDeleteBidPack(bidPackId);

  return (
    <BidPackFormTabs
      title="Edit"
      bidPack={fetchedBidPack}
      onSave={(bidPack: BidPack) => updateBidPack(toBidPackWriteRequest(bidPack))}
      onDelete={() => deleteBidPack(bidPackId)}
    />
  );
};
